import { GameFontStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameFontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { HorizontalLayout } from "@lib/titan2/dist/game/control/layout/HorizontalLayout";
import { VerticalLayout } from "@lib/titan2/dist/game/control/layout/VerticalLayout";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { CommonLang } from "@lib/titan2/dist/game/view/lang/CommonLang";
import { AbstractResponsibleGamingDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractResponsibleGamingDialogProperties";
import { AbstractResponsibleGamingPanelProperties } from "@lib/titan2/dist/game/view/properties/AbstractResponsibleGamingPanelProperties";
import { CommonStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import * as PIXI from "pixi.js";
/**
 * ResponsibleGamingDialogProperties.ts
 */
export class ResponsibleGamingDialogProperties extends AbstractResponsibleGamingDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        const panelSize = 836;
        const buttonSize = 209;
        const buttonEmptySize = panelSize - 2 * buttonSize;
        const leftButtonX = buttonEmptySize / 3;
        const rightButtonX = panelSize - leftButtonX - buttonSize;
        this.panelProperties.position = new PIXI.Point(92, 70);
        this.panelProperties.layout = new VerticalLayout(15);
        this.cancelButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_2, CommonStyle.MODULE, new PIXI.Point(leftButtonX, 840));
        this.cancelButtonProperties.textFieldProperties = new TextFieldProperties(GameFontStyle.PLAYER_CONTROL_BUTTONS, undefined, CommonLang.CANCEL_BUTTON);
        this.cancelButtonProperties.textFieldProperties.size = new PIXI.Point(190, 90);
        this.cancelButtonProperties.textFieldOffset.set(0, -4);
        this.confirmButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_2, CommonStyle.MODULE, new PIXI.Point(rightButtonX, 840));
        this.confirmButtonProperties.textFieldProperties = new TextFieldProperties(GameFontStyle.PLAYER_CONTROL_BUTTONS, undefined, CommonLang.SAVE_BUTTON);
        this.confirmButtonProperties.textFieldProperties.size = new PIXI.Point(190, 90);
        this.confirmButtonProperties.textFieldOffset.set(0, -4);
        this.extraSpinPanelProperties = new ResponsibleGamingPanelProperties(CommonLang.RESPONSIBLE_GAMING_EXTRA_SPIN);
        this.spinPricePanelProperties = new ResponsibleGamingPanelProperties(CommonLang.RESPONSIBLE_GAMING_SPIN_PRICE);
        this.singleGameStakePanelProperties = new ResponsibleGamingPanelProperties(CommonLang.RESPONSIBLE_GAMING_SINGLE_GAME_STAKE);
        this.maximumLossPanelProperties = new ResponsibleGamingPanelProperties(CommonLang.RESPONSIBLE_GAMING_MAXIMUM_LOSS);
    }
}
export class ResponsibleGamingPanelProperties extends AbstractResponsibleGamingPanelProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.titleFieldProperties.position = new PIXI.Point(326, 0);
        this.titleFieldProperties.size = new PIXI.Point(500, 60);
        this.titleFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.panelProperties.position = new PIXI.Point(260, 50);
        this.panelProperties.layout = new HorizontalLayout(35, ControlConstants.CENTER);
        this.optionProperties.textFieldProperties.size = new PIXI.Point(90, 90);
        this.optionProperties.textFieldOffset.set(3, 3);
    }
}
//# sourceMappingURL=ResponsibleGamingDialogProperties.js.map